(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["annonces-defilantes-noel"] && !Shopify.designMode) return;
  try {
    
  // Each half must cover the full banner so the loop never exposes an empty area.
  if (!customElements.get('xbar-marquee')) {
    customElements.define('xbar-marquee', class extends HTMLElement {
      connectedCallback() {
        this.groups = Array.from(this.querySelectorAll('.xbar__grp'));
        if (this.groups.length !== 2) return;
        if (!this.originalItems) {
          this.originalItems = Array.from(this.groups[0].children).map(item => item.cloneNode(true));
        }
        this.resizeObserver = new ResizeObserver(() => this.fillTrack());
        this.resizeObserver.observe(this);
        this.fillTrack();
        if (document.fonts) document.fonts.ready.then(() => {
          if (this.isConnected) this.fillTrack();
        });
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      fillTrack() {
        const width = this.clientWidth;
        if (!width || !this.originalItems.length) return;
        this.groups.forEach(group => {
          group.replaceChildren(...this.originalItems.map(item => item.cloneNode(true)));
        });
        const unitWidth = this.groups[0].getBoundingClientRect().width;
        if (!unitWidth) return;
        const repeats = Math.max(1, Math.ceil(width / unitWidth));
        this.groups.forEach(group => {
          for (let i = 1; i < repeats; i++) {
            this.originalItems.forEach(item => {
              const copy = item.cloneNode(true);
              copy.setAttribute('aria-hidden', 'true');
              group.appendChild(copy);
            });
          }
        });
        // Keep the same reading speed when a wide screen needs extra copies.
        this.style.setProperty('--xb-duration', 'calc(var(--xb-sp) * ' + repeats + ')');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
